import SearchService from './search.service';

export default class SearchArea {
  createForm() {
    this.form = document.createElement('form');
    this.form.classList.add('search');

    this.createSerchInput(this.form);

    this.createSerchButtonRequest(this.form);

    this.createSerchButtonClear(this.form);

    this.createSerchTranslateArea(this.form);

    document.body.appendChild(this.form);
  }

  createSerchInput(form) {
    this.formInput = document.createElement('input');
    this.formInput.setAttribute('type', 'text');
    this.formInput.setAttribute('autofocus', '');
    this.formInput.setAttribute('placeholder', 'Search Movie');
    this.formInput.classList.add('search__input');
    this.formInput.style.backgroundImage = "url('../../assets/search.svg')";
    form.appendChild(this.formInput);
  }

  createSerchButtonClear(form) {
    this.formSerchIcon = document.createElement('span');
    this.formSerchIcon.classList.add('serch_icon-clear');
    form.appendChild(this.formSerchIcon);
  }

  createSerchButtonRequest(form) {
    this.formButton = document.createElement('button');
    this.formButton.setAttribute('type', 'submit');
    this.formButton.classList.add('search__button');
    this.formButton.innerHTML = 'Search';
    form.appendChild(this.formButton);
  }

  createSerchTranslateArea(form) {
    this.formTranslateArea = document.createElement('div');
    this.formTranslateArea.classList.add('search__translate-area');
    form.appendChild(this.formTranslateArea);
  }

  addEventOnSearch() {
    document
      .querySelector('.search__input')
      .addEventListener('change', ({ target }) => {
        this.title = target;
      });
  }

  addEventOnButton() {
    document.querySelector('.search__button').addEventListener('click', async (buttonEvent) => {
      buttonEvent.preventDefault();
      const swiper = document.querySelector('.swiper-container');
      if (swiper) { swiper.remove(); }
      this.serchValue = document.querySelector('.search__input').value;
      const searchService = new SearchService();
      if (this.serchValue) {
        searchService.getBySearhcRequest(this.serchValue);
      } else {
        searchService.getBySearhcRequest();
      }
    });
  }

  clearButton() {
    const serchInput = document.querySelector('.search__input');
    this.clearButton = document.querySelector('.serch_icon-clear');
    this.clearButton.addEventListener('click', () => {
      serchInput.value = '';
    });
  }

  firstSerchBeforRequest() {
    this.searchService = new SearchService();
    this.searchService.getBySearhcRequest();
  }

  init() {
    this.createForm();
    this.firstSerchBeforRequest();
    this.addEventOnSearch();
    this.addEventOnButton();
    this.clearButton();
  }
}
